<template>
    <v-container class="secondary-font py-0 my-0" style="font-size: 1rem; height: 200px;">
        <template v-if="!isLoaded">
            <v-skeleton-loader type="card" height="100px" class="mb-2" />
            <v-skeleton-loader type="card" height="100px" />
        </template>
        <template v-else>
            <div class="live-score-wrapper rounded-lg">
                <div class="live-score-logo px-2 py-0 my-0">
                    <img height="auto" width="150px" :src="require('@/assets/main_logo.png')">
                </div>
                <div class="live-score-rows">
                    <v-row style="height: 98.5px; background-color: #232323; color: white;" class="px-0 py-0 my-0 rounded-tr-lg" align="center" justify="center">
                        <v-col cols="4" align="start" class="px-0 pl-5">
                            <div style="display: inline-block; font-size: 1rem;">
                                <div> {{ getMatchTitle() }} </div>
                                <div>
                                    {{ (matchDetails.round > 0 ? ('Matchday ' + matchDetails.round + ', ') : '') + (matchDetails.cup ? 'Κύπελλο' : (matchDetails.phase === 'regular_season' ? 'Regular Season' : (matchDetails.phase === 'playoffs' ? 'Play Offs' : 'Match'))) }}
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="4" align="center" class="px-0">
                            <div v-fit-text="{ max: 1.3, min: 0.8, lines: 2 }" class="font-weight-bold team-name">
                                <!-- {{ matchDetails.team1.nickName ? matchDetails.team1.nickName : matchDetails.team1.name }} -->
                                {{ matchDetails.team1.name }}
                            </div>
                            <div>
                                <span v-for="n in team1Fouls >= 5 ? 5 : team1Fouls" :key="`n-${n}`">
                                    <v-icon large :color="team1Fouls >= 5 ? 'red' : 'teal'">mdi-minus-thick</v-icon>
                                </span>
                                <span v-for="w in ((5 - team1Fouls) <= 0 ? 0 : (5 - team1Fouls))" :key="`w-${w}`">
                                    <v-icon large color="white" class="icon-outline">mdi-minus-thick</v-icon>
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="2" align="end" class="px-0 py-0 my-0">
                            <v-avatar style="border-radius: 10px;" size="80px" class="mr-3" :style="`background-color: white; border-radius: 50%;`">
                                <img :src="`${assetsUrl}/${matchDetails.team1?.logo}`" height="80px" width="auto">
                            </v-avatar>
                        </v-col>
                        <v-col cols="2" align="center" style="font-size: 2.5rem;" class="px-0 score-cell score-cell-top" :style="`border-left: 8px solid ${scoreColors.team1};`">
                            <span>{{ team1Score }}</span>
                            <transition name="score-pop">
                                <div v-if="scoreOverlay.team1" :key="scoreOverlay.team1.key" class="score-overlay">
                                    <span class="score-overlay__points custom-teal-text">+{{ scoreOverlay.team1.points }}</span>
                                </div>
                            </transition>
                        </v-col>
                    </v-row>
                    <v-row class="py-0 my-0" justify="center" align="center">
                        <v-col cols="12" class="py-0 my-0 custom-teal" style="height: 3px;" />
                    </v-row>
                    <v-row style="height: 98.5px; background-color: #232323; color: white;" class="px-0 my-0 py-0 rounded-br-lg" align="center" justify="center">
                        <v-col cols="1" style="font-size: 1.7rem;" align="start" class="py-0 my-0">
                            {{ periodNames[quarter] }}
                        </v-col>
                        <v-col cols="3" style="font-size: 2rem;" align="center" class="py-0 my-0">
                            {{ `${minutes}:${seconds}` }}
                        </v-col>
                        <!-- <v-col cols="1" style="color: white; background-color: #b03e00; font-size: 1rem;" class="px-0">
                            24
                        </v-col> -->
                        <v-col cols="4" align="center" class="px-0">
                            <div v-fit-text="{ max: 1.3, min: 0.8, lines: 2 }" class="font-weight-bold team-name">
                                <!-- {{ matchDetails.team2.nickName ? matchDetails.team2.nickName : matchDetails.team2.name }} -->
                                {{ matchDetails.team2.name }}
                            </div>
                            <div>
                                <span v-for="i in team2Fouls >= 5 ? 5 : team2Fouls" :key="`i-${i}`">
                                    <v-icon large :color="team2Fouls >= 5 ? 'red' : 'teal'">mdi-minus-thick</v-icon>
                                </span>
                                <span v-for="j in ((5 - team2Fouls) <= 0 ? 0 : (5 - team2Fouls))" :key="`j-${j}`">
                                    <v-icon large color="white" class="icon-outline">mdi-minus-thick</v-icon>
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="2" align="end" class="px-0 py-0 my-0">
                            <v-avatar style="border-radius: 10px;" size="80px" class="mr-3" :style="`background-color: white; border-radius: 50%;`">
                                <img :src="`${assetsUrl}/${matchDetails.team2?.logo}`" height="80px" width="auto">
                            </v-avatar>
                        </v-col>
                        <v-col cols="2" align="center" style="font-size: 2.5rem;" class="px-0 score-cell score-cell-bottom" :style="`border-left: 8px solid ${scoreColors.team2};`">
                            <span>{{ team2Score }}</span>
                            <transition name="score-pop">
                                <div v-if="scoreOverlay.team2" :key="scoreOverlay.team2.key" class="score-overlay">
                                    <span class="score-overlay__points custom-teal-text">+{{ scoreOverlay.team2.points }}</span>
                                </div>
                            </transition>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </template>
    </v-container>
</template>

<script>
    import matchService from '@/services/match'
    import { BACKGROUNDS, getMatchColors } from '@/utils/colors'
    import { getClockFromLogs, hasMatchEnded } from '@/utils/matchLive'
    import { subscribeLiveEvents } from '@/utils/liveEvents'
    import fitText from '@/utils/fitText'

    // Any of these in the play-by-play means the game is on; declaring the players on court does not
    const GAME_ACTION_KEYS = [
        'points', 'twoPointAttempts', 'threePointAttempts', 'freeThrowAttempts', 'offensiveRebounds', 'defensiveRebounds',
        'rebounds', 'assists', 'steals', 'turnovers', 'blockedShots', 'personalFouls', 'technicalFouls', 'unsportsmanlikeFouls',
        'disruptiveFouls', 'flagrantFouls'
    ]
    export default {
        directives: { fitText },
        props: {
            id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                periodNames: {
                    0: '1st',
                    1: '1st',
                    2: '2nd',
                    3: '3rd',
                    4: '4th',
                    5: 'OT',
                    6: '2nd OT',
                    7: '3rd OT',
                    8: '4th OT',
                    9: '5th OT',
                    10: '6th OT'
                },
                events: [],
                timerEvent: null,
                timer: null,
                paused: true,
                // a clock start arrived (the opening pregame / live-score decision is then left to the clock)
                clockEventSeen: false,
                quarter: 1,
                timerInterval: null,
                // the running clock is worked out from when it was started, so it does not drift
                clockStartedAt: 0,
                clockStartValue: 0,
                unsubscribe: null,
                scoreInitialized: false,
                scoreOverlay: { team1: null, team2: null },
                scoreOverlayTimers: { team1: null, team2: null },
                matchDetails: {
                    team1: { name: '', points: 0, personalFouls: 0, technicalFouls: 0, logo: '', color: '' },
                    team2: { name: '', points: 0, personalFouls: 0, technicalFouls: 0, logo: '', color: '' },
                    leagueTitle: '',
                    round: '',
                    cup: false,
                    phase: ''
                }
            }
        },
        computed: {
            // team colours that show on the dark scoreboard and differ from each other
            scoreColors() {
                const details = this.matchDetails || {}
                return getMatchColors(details.team1, details.team2, BACKGROUNDS.dark)
            },
            team1Score() {
                return this.matchDetails.team1Score ? this.matchDetails.team1Score : this.matchDetails.team1.points
            },
            team2Score() {
                return this.matchDetails.team2Score ? this.matchDetails.team2Score : this.matchDetails.team2.points
            },
            team1Fouls() {
                return this.teamFouls(this.matchDetails.team1)
            },
            team2Fouls() {
                return this.teamFouls(this.matchDetails.team2)
            },
            minutes() {
                const t = Math.max(0, Number(this.timer) || 0)
                const temp = Math.floor(t / 60000)
                return (temp < 10 ? '0' : '') + temp
            },
            seconds() {
                const t = Math.max(0, Number(this.timer) || 0)
                const temp = Math.floor((t % 60000) / 1000)
                return (temp < 10 ? '0' : '') + temp
            },
            isLoaded() {
                // Adjust this logic as needed for your data
                return !!this.matchDetails.team1.name && !!this.matchDetails.team2.name
            }
        },
        watch: {
        },
        beforeDestroy() {
            if (this.unsubscribe) this.unsubscribe()
            this.stopClock()
            clearTimeout(this.scoreOverlayTimers.team1)
            clearTimeout(this.scoreOverlayTimers.team2)
        },
        mounted() {
            this.unsubscribe = subscribeLiveEvents(this.id, {
                score: this.onScoreEvent,
                timer: this.onTimerEvent,
                // a (re)connection opens with the current score: not a new basket
                onOpen: () => {
                    this.scoreInitialized = false
                }
            })
        },
        created() {
            this.timer = 600000
            // The pregame screens stay until the clock is started, whoever is already declared on court;
            // a match that was ended in the CMS opens on its full-time screens
            this.getOpeningScreen().then(screen => {
                // the clock may have been pressed while the logs were loading: its events decide then
                if (this.clockEventSeen) return
                console.info(`Live data: opened on ${screen}`)
                this.$emit('setShowScreen', screen)
            })
        },
        methods: {
            // the fouls of the team in the period, all of them team fouls (the unsportsmanlike one before FIBA 2026, the
            // disruptive and the flagrant one after)
            teamFouls(team) {
                return ['personalFouls', 'technicalFouls', 'unsportsmanlikeFouls', 'disruptiveFouls', 'flagrantFouls']
                    .reduce((total, key) => total + (Number(team && team[key]) || 0), 0)
            },
            getMatchTitle() {
                if (this.matchDetails.cupLeague) {
                    return this.matchDetails.cupLeague.title
                } else if (this.matchDetails.leagueTitle) {
                    return this.matchDetails.leagueTitle
                } else {
                    return 'Friendly'
                }
            },
            // The timer stream only sends what happens from now on, so on page load the play-by-play
            // tells where the match is: ended in the CMS (the end of game log), already on
            // (a game action, or a period after the 1st), or still before tip-off
            getOpeningScreen() {
                return matchService.getMatchLogs(this.$route.params.id).then(resp => {
                    const logs = Array.isArray(resp.data) ? resp.data : []
                    // the stream has no clock to send after a restart of the server, until the stats app sends one:
                    // the time of the play-by-play meanwhile, stopped
                    const clock = getClockFromLogs(logs)
                    if (clock && !this.timerEvent && !hasMatchEnded(logs)) {
                        this.quarter = clock.period
                        this.setClock(clock.timer, false)
                    }
                    if (hasMatchEnded(logs)) return 'full-time'
                    const started = logs.some(log => (Number(log.period) || 0) > 1 || GAME_ACTION_KEYS.some(key => (Number(log[key]) || 0) > 0))
                    return started ? 'live-score' : 'pregame'
                }).catch(e => {
                    console.error('Failed to load the match logs', e)
                    return 'pregame'
                })
            },
            onScoreEvent(details) {
                // the match colour of a team was changed in the stats app: nothing else is news
                if (details && details.colorsOnly) {
                    ;['team1', 'team2'].forEach(key => {
                        const team = this.matchDetails[key]
                        const fresh = details[key]
                        if (!team || !fresh || team.id !== fresh.id) return
                        this.$set(team, 'brandColor', fresh.brandColor || null)
                        this.$set(team, 'color', fresh.color)
                    })
                    return
                }
                const prevTeam1Score = Number(this.team1Score) || 0
                const prevTeam2Score = Number(this.team2Score) || 0
                this.matchDetails = details
                // The first event carries the current score, not a new basket
                if (this.scoreInitialized) {
                    this.showScoreOverlay('team1', (Number(this.team1Score) || 0) - prevTeam1Score)
                    this.showScoreOverlay('team2', (Number(this.team2Score) || 0) - prevTeam2Score)
                }
                if (!this.scoreInitialized && ((Number(this.team1Score) || 0) > 0 || (Number(this.team2Score) || 0) > 0)) {
                    this.$emit('started', `score ${this.team1Score}-${this.team2Score}`)
                }
                this.scoreInitialized = true
                // Lets the break screens show the same, live score as the scoreboard
                this.$emit('score', {
                    team1Id: this.matchDetails.team1?.id,
                    team2Id: this.matchDetails.team2?.id,
                    team1Score: Number(this.team1Score) || 0,
                    team2Score: Number(this.team2Score) || 0
                })
            },
            // +1, +2 or +3 over the score of the team that scored
            showScoreOverlay(team, points) {
                if (![1, 2, 3].includes(points)) return
                clearTimeout(this.scoreOverlayTimers[team])
                this.scoreOverlay[team] = { points, key: Date.now() }
                this.scoreOverlayTimers[team] = setTimeout(() => {
                    this.scoreOverlay[team] = null
                }, 2500)
            },
            stopClock() {
                clearInterval(this.timerInterval)
                this.timerInterval = null
            },
            // Shows `value` (ms) on the clock and, when running, counts it down from now
            setClock(value, running) {
                this.stopClock()
                const clock = Math.max(0, Number(value) || 0)
                this.timer = clock
                this.paused = !running || clock === 0
                if (this.paused) return
                this.clockStartedAt = Date.now()
                this.clockStartValue = clock
                this.timerInterval = setInterval(() => {
                    const remaining = this.clockStartValue - (Date.now() - this.clockStartedAt)
                    // whole seconds, as on the stats app's clock
                    this.timer = Math.max(0, Math.ceil(remaining / 1000) * 1000)
                    if (remaining <= 0) {
                        this.stopClock()
                        this.paused = true
                    }
                }, 250)
            },
            onTimerEvent(timerEvent) {
                this.timerEvent = timerEvent
                const status = timerEvent.timerEventStatus
                // The end of a period only switches the screen: the stats app sends the next period's clock with it
                if (status === 'period_end') {
                    this.stopClock()
                    this.paused = true
                    const period = Number(timerEvent.period)
                    if (period === 2) {
                        this.$emit('setShowScreen', 'half-time')
                    } else if (period >= 4) {
                        this.$emit('setShowScreen', 'full-time')
                    } else {
                        this.$emit('setShowScreen', 'period-end')
                    }
                    return
                }

                this.quarter = timerEvent.period
                // Time has really run: a later period, or a clock value between 0 and a full period.
                // An event without a clock value (or a reset to 10:00) keeps the pregame on
                const clock = timerEvent.timer === null || timerEvent.timer === undefined || timerEvent.timer === ''
                    ? NaN
                    : Number(timerEvent.timer)
                if (Number(timerEvent.period) > 1 || (Number.isFinite(clock) && clock > 0 && clock < 600000)) {
                    this.$emit('started', `timer ${status} period ${timerEvent.period} clock ${timerEvent.timer}`)
                }

                // The clock as it is at (re)connection: set it, without replaying its screen
                if (timerEvent.snapshot) {
                    this.setClock(clock, status === 'start')
                    if (!this.paused) {
                        this.clockEventSeen = true
                        this.$emit('setShowScreen', 'live-score')
                    }
                    return
                }

                if (status === 'start') {
                    this.clockEventSeen = true
                    if (clock === 600000) {
                        this.$emit('setShowScreen', 'starters')
                    } else if (clock > 0) {
                        this.$emit('setShowScreen', 'live-score')
                    }
                    this.setClock(clock, true)
                } else if (status === 'timeout') {
                    this.setClock(clock, false)
                    this.$emit('setShowScreen', 'timeout')
                } else if (status === 'end_match') {
                    this.setClock(0, false)
                    console.log('end of game')
                    this.$emit('setShowScreen', 'full-time')
                } else if (status === 'edit') {
                    this.setClock(clock, !this.paused)
                } else {
                    // stop: the clock only pauses, the break screens come with period_end / timeout
                    this.setClock(clock, false)
                }
            }
        }
    }
</script>

<style lang="css" scoped>
    .live-score-wrapper {
        display: flex;
        background-color: #232323;
    }

    .live-score-logo {
        height: 200px;
        display: flex;
        align-items: center;
        flex: 0 0 auto;
    }

    .live-score-rows {
        flex: 1;
        min-width: 600px;
    }

    /* never cut: a long name goes on two lines (between words) and is set smaller if it still does not fit */
    .team-name {
        line-height: 1.1;
        text-align: center;
        max-width: 100%;
    }

    /* Clip the overlay so it rises from inside the cell and follows the wrapper's rounded corners */
    .score-cell {
        position: relative;
        overflow: hidden;
    }

    .score-cell-top {
        border-top-right-radius: 8px;
    }

    .score-cell-bottom {
        border-bottom-right-radius: 8px;
    }

    .score-overlay {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #232323;
    }

    .score-overlay__points {
        font-size: 3.2rem;
        font-weight: 900;
        line-height: 1;
    }

    .score-pop-enter-active {
        transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .score-pop-leave-active {
        transition: transform 0.3s ease-in;
    }

    .score-pop-enter,
    .score-pop-leave-to {
        transform: translateY(100%);
    }

    .icon-outline {
        text-shadow:
            -1px -1px 0 #000,
            1px -1px 0 #000,
            -1px  1px 0 #000,
            1px  1px 0 #000;
    }
</style>
